import styled, { css } from 'styled-components';

export const ChildDietsHistory = styled.div`
    ${() => css`
        display: grid;
        grid-template-rows: repeat(1, 1fr);
        grid-template-columns: repeat(1, 1fr);
        gap: 4px;
        margin-bottom: 16px;
    `}
`;
